export default "__VITE_ASSET__D6rFfA3x__"